import { catchError, EMPTY, firstValueFrom, map } from 'rxjs';
import { Coords, Project } from '../../../swagger-api';
import { MapFilters } from '../map.enum';
import { MapItemDetailsProvider } from './map-item-details.provider';

export class MapProjectDetailsProvider extends MapItemDetailsProvider {
  readonly filter = MapFilters.PROJECTS;

  async fetchLocationForItemById(id: string): Promise<Coords> {
    return await firstValueFrom(
      this.apiService.restSocialProjectsGet(id).pipe(
        map((project: Project) => project.location.center),
        catchError(() => EMPTY),
      ),
    );
  }

  getMarkerIdByEntityId(id: string): string {
    return id;
  }
}
